
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";

import CustomButton from "../../../common/CustomButton";
import CustomInput from "../../../common/CustomInput";
import { FillEye, FillEyeSlash } from "../../../common/CustomIcons";
import CustomAppleAuth from "../../../common/CustomAppleAuth";
import CustomGoogleAuth from "../../../common/CustomGoogleAuth";
import SuccessPagePromo from "../../onboarding/Components/SuccessPagePromo";

import { validations } from "../../../constants";
import { delay } from "../../../utils";
import { callSocket } from "../../../utils/socket";
import { checkIfUsingMobileApp } from "../../../utils/userResource";
import { removeBRGPatientCookie } from "../../../utils/cookie";

import { LoadAccountDetails, UserOnboarding } from "../../../redux/v2/user/actions";
import { CreatePurchaseUsingCoupon } from "../../../redux/v2/plan/actions";
import { EmailInvitationRegistered, LinkInvitationDetails } from "../../../redux/v2/user/actions";
import { SetModalProperties } from "../../../redux/v2/utils/actions";

function SlideSignup(props) {
    const navigate = useNavigate();
    const isUsingMobileApp = checkIfUsingMobileApp();
    const { authProviderCredential } = props;
    const { invitationDetails } = props.User;
    const cons = ["Stay Consistent", "Be More Active"];
    const [signupInfo, setSignupInfo] = useState({
        email: "",
        password: "",
        confirmPassword: "",
        username: "",
    });
    const [emailError, setEmailError] = useState("asdas");

    const [showPassword, setShowPassword] = useState(false);
    const [passwordError, setPasswordError] = useState("");

    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [confirmPasswordError, setConfirmPasswordError] = useState("");

    const updateSignupInfo = (e) => {
        const { name, value } = e.target;

        setSignupInfo({
            ...signupInfo,
            [name]: value,
        });
    }

    const OnboardUser = (data) => {
        props.moveNext();

        delay(async () => {

            const res = await props.UserOnboarding(data);
            if (res) {
                if (invitationDetails?.eventID) {
                    // const toastId = toast.loading("Setting up Free Trial Account...");
                    const res = await props.CreatePurchaseUsingCoupon("14DFT");
                    if (res.status == 200) {
                        await props.LoadAccountDetails();
                        if (invitationDetails?.signupType == "brgpatient") {
                            props.EmailInvitationRegistered(invitationDetails?.eventID);
                        } else if (invitationDetails?.signupType == "therapistinvite") {
                            props.LinkInvitationDetails({ ...invitationDetails });
                        }
                        removeBRGPatientCookie();

                        // toast.dismiss(toastId);

                        props.SetModalProperties({
                            id: "success-page-promo-modal",
                            isShow: true,
                            title: "",
                            height: "100%",
                            body: <>
                                <SuccessPagePromo close={() => {
                                    localStorage.setItem("requirement_status", 3);
                                    localStorage.setItem("survey_not_done", true);
                                    localStorage.setItem("access-token", localStorage.getItem("temp-access-token"));
                                    localStorage.removeItem("temp-access-token");

                                    props.SetModalProperties({
                                        isShow: false,
                                        title: "",
                                        height: "0%",
                                        body: <>
                                        </>,
                                        actions: [],
                                        showCloseButton: false,
                                    });

                                    navigate("/");

                                }} />
                            </>,
                            actions: [],
                            showCloseButton: false,
                        });
                    }
                } else {
                    props?.setUserID(res);
                }
            } else {
                delay(async () => {
                    props.moveBack({}, props?.slide);
                }, 500);
            }

        }, 1000);
    }

    const PreOnboarding = (authData) => {
        OnboardUser(authData?.provider == "apple" ? {
            ...props?.preRegistrationDetails,
            signupInfo: {
                email: authData?.email,
                password: "",
                confirmPassword: "",
            },
            email: authData?.email,
            authProvider: authData?.provider,
            authProviderDetails: authData,
            medium: authData?.medium || "mobile",
        } : {
            ...props?.preRegistrationDetails,
            signupInfo: {
                email: authData?.user?.email,
                password: "",
                confirmPassword: "",
            },
            email: authData?.user?.email,
            authProvider: authData?.provider,
            authProviderDetails: authData,
            medium: authData?.medium || "mobile",
        });
    }

    useEffect(() => {
        const validatePassword = validations.passwordRegex.test(signupInfo?.password);
        setPasswordError("");
        setConfirmPasswordError("");

        if (signupInfo?.password && !validatePassword) {
            setPasswordError(validations.passwordValidation2);
        }

        if ((signupInfo?.confirmPassword && signupInfo?.password) && signupInfo?.confirmPassword != signupInfo?.password) {
            setConfirmPasswordError(validations.passwordMatchValidation);
        }

    }, [signupInfo?.password, signupInfo?.confirmPassword]);

    useEffect(() => {
        const validateEmail = validations.emailRegex.test(signupInfo?.email);
        setEmailError("");

        if (signupInfo?.email && !validateEmail) {
            setEmailError(validations.emailRegexValidation);
        }

    }, [signupInfo?.email]);

    useEffect(() => {
        if (authProviderCredential) {
            PreOnboarding(authProviderCredential);
        }
    }, [authProviderCredential]);


    let disable = emailError || passwordError || confirmPasswordError || !signupInfo?.email || !signupInfo?.password || !signupInfo?.confirmPassword;
    const dt = localStorage.getItem("indi-device-type");
    const ip = localStorage.getItem("indi-platform");
    const isSafari = navigator.userAgent?.includes("Safari")

    return (
        <div id="uo-signup" className="uo-component div-45-55">
            <div id="uo-s-banner">
                {/* <img src="/assets/images/onboarding/onboarding-signup-shape.png" className="polygon" /> */}
                {/* <svg id="uo-s-polygon" width="658" height="700" viewBox="0 0 329 330" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M221.474 322.148C239.416 337.027 266.745 327.526 271.587 304.726L328.263 37.8622C333.278 14.2453 310.564 -5.78694 287.759 2.14118L21.0873 94.85C-1.7175 102.778 -7.10661 132.58 11.4776 147.993L221.474 322.148Z" fill="url(#paint0_linear_1_575)" />
                    <defs>
                        <linearGradient id="paint0_linear_1_575" x1="-23.9913" y1="224.991" x2="403.847" y2="76.2528" gradientUnits="userSpaceOnUse">
                            <stop offset="1" stop-color="#8B1E3F" />
                        </linearGradient>
                    </defs>
                </svg> */}
                <img src="/assets/images/onboarding/onboarding-signup-banner.png" className="pi-banner" />

            </div>
            <div id="uo-s-inputs">
                <div className="bottom-text-area">
                    <h4>Create Your Account</h4>
                    <h6>Enter your email and create a password to start your fitness routine!</h6>
                </div>
                <div id="uo-s-form">
                    {/* 
                        // HONEYPOT
                    */}
                    <div
                        className="d-sm-flex align-items-center" //HONEY-P
                        style={{
                            position: "absolute",
                            top: "-99999px",
                        }}
                    >
                        <CustomInput
                            type="text"
                            placeholder="Username"
                            className="form-control i-box"
                            value={""}
                            name="username"
                            onChange={() => { }}
                            onBlur={(e) => {
                            }}
                        />
                    </div>

                    <div className="inpt-grp">
                        <CustomInput
                            type="text"
                            placeholder="Email"
                            style={{
                                borderColor: !emailError ? "lightgrey" : "red",
                            }}
                            className="form-control i-box"
                            value={signupInfo?.email}
                            name="email"
                            onChange={updateSignupInfo}
                            onBlur={(e) => {
                            }}
                        />
                        {emailError && <p className="error">{emailError}</p>}
                    </div>

                    <div className="inpt-grp">
                        <CustomInput
                            type={showPassword ? "text" : "password"}
                            placeholder="Password"
                            style={{
                                borderColor: !passwordError ? "lightgrey" : "red",
                            }}
                            className="form-control i-box"
                            value={signupInfo?.password}
                            name="password"
                            onChange={updateSignupInfo}
                            onBlur={(e) => {
                            }}
                        />
                        {showPassword ? <FillEye onClick={() => { setShowPassword(!showPassword) }} /> : <FillEyeSlash onClick={() => { setShowPassword(!showPassword) }} />}
                        {passwordError && <p className="error">{passwordError}</p>}

                    </div>

                    <div className="inpt-grp">
                        <CustomInput
                            type={showConfirmPassword ? "text" : "password"}
                            placeholder="Confirm Password"
                            style={{
                                borderColor: !confirmPasswordError ? "lightgrey" : "red",
                            }}
                            className="form-control i-box"
                            value={signupInfo?.confirmPassword}
                            name="confirmPassword"
                            onChange={updateSignupInfo}
                            onBlur={(e) => {
                            }}
                        />

                        {showConfirmPassword ? <FillEye onClick={() => { setShowConfirmPassword(!showConfirmPassword) }} /> : <FillEyeSlash onClick={() => { setShowConfirmPassword(!showConfirmPassword) }} />}
                        {confirmPasswordError && <p className="error">{confirmPasswordError}</p>}
                    </div>


                    <CustomButton disabled={disable} className="uo-button active" onClick={async () => {
                        OnboardUser({ ...props?.preRegistrationDetails, signupInfo: signupInfo, email: signupInfo?.email });
                    }}>Continue</CustomButton>
                </div>
                {(dt === "ios" || ip == "ios-app" || isSafari) && <CustomAppleAuth authType="signup" onClick={isUsingMobileApp ? () => {
                    callSocket(`interact-onboarding`, { type: "apple-auth", sessionID: props?.sessionID });
                } : null} proceedSignup={(authData) => {
                    PreOnboarding({
                        email: authData?.email_address,
                        provider: authData?.auth_provider,
                        ...authData?.auth_provider_details,
                        medium: authData?.medium,
                    });
                }} />}
                <CustomGoogleAuth authType="signup" onClick={isUsingMobileApp ? () => {
                    callSocket(`interact-onboarding`, { type: "google-auth", sessionID: props?.sessionID });
                } : null} proceedSignup={(authData) => {
                    PreOnboarding({
                        user: {
                            email: authData?.email_address,
                        },
                        provider: authData?.auth_provider,
                        ...authData?.auth_provider_details,
                        medium: authData?.medium,
                    });
                }} />

            </div>
        </div>
    );
}

const mapStateToProps = (state) => ({
    User: state.User,
});

export default connect(mapStateToProps, {
    UserOnboarding,
    CreatePurchaseUsingCoupon,
    LoadAccountDetails,
    EmailInvitationRegistered,
    LinkInvitationDetails,
    SetModalProperties,
})(SlideSignup);
